import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const DivName = styled.div`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize[theme.fontSizeType].fs12};
  color: ${({ theme }) => theme.colors?.text.primary};
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors?.gray03};
  width: fit-content;
  max-width: 70%;
  padding: 1.5rem;
`;
